import React, {useState, useEffect} from "react";
import SubBanner from "../../../components/SubBanner";
import bannerImg from "../../../assets/img/resources_banner.png";
import { useParams, useNavigate } from "react-router-dom";
import instance from "../../../services/services";
import { BOARD_DETAIL_URL } from "../../../utils/urls";

function BlogDetail(){
  // 0: Notice, 1: FAQ, 2: 자료실, 3:Blog
  const [activeTab, setActiveTab] = useState(3);
  const { b_seq } = useParams();
  const [blogDetail, setBlogDetail] = useState(null);
  const navigate = useNavigate();
  // 배너 탭
  const tabList = [
    { label : 'Notice', url : '/resources/notice'},
    { label : 'FAQ', url : '/resources/faq'},
    { label : '자료실', url : '/resources/data'},
    { label : 'Blog', url : '/resources/blog'},
  ]

  useEffect(()=> {
    const fetchBlogDetail = async () => {
      try {
        const response = await instance.post(BOARD_DETAIL_URL, {
          boardid: "blog",
          b_seq: b_seq,
        });
        setBlogDetail(response.data.data);
      } catch (error) {
        console.error('블로그 상세 정보 가져오기 오류:', error);
      }
    };
    fetchBlogDetail();
  }, [b_seq]);

  return(
    <div className="resources">
      {/* 배너 */}
      <SubBanner
          bgImg={bannerImg}
          title= {'Blog'}
          tabs={tabList?.map((tab,idx) => ({
            label : tab.label,
            url : tab.url,
            active: activeTab === idx,
            onClick: () => setActiveTab(idx),
          }))}
          location={[
            { label: "Resources", url: "/resources" },
            { label: "Blog", url: "/resources/blog", active: true }
          ]}
        />

      <section className="sub_section mt-[170px] mb-[80px] mx-auto">
        <h3 className="detial_title pb-[32px]">Blog</h3>
        {/* 공지사항 타이틀 */}
        <div className="p-[16px] border-b-[1px] border-b-[#E8E8E8]">
          <div className="notice_title">
            <h4>{blogDetail?.subject}</h4>
            <span className="mt-[4px]">{blogDetail?.regist_date.split(' ')[0]}</span>
          </div>
        </div>

        {/* 공지사항 컨텐츠 */}
        <div className="notice_con unset py-[40px] px-[16px] border-b-[1px] border-b-[#E8E8E8]">
          <div className="notice_content" dangerouslySetInnerHTML={{ __html: blogDetail?.contents }} />
          <ul className="tag">
            {blogDetail?.keyword?.split(',').map((tag, index) => (
              <li key={index}>#{tag}</li>
            ))}
          </ul>
        </div>


        {/* 목록 */}
        <div className="list_btn mt-[32px] flex justify-center">
          <button type="button" onClick={() => navigate('/resources/blog')}>목록</button>
        </div>

      </section>
    </div>
  )
};

export default BlogDetail;